/**
 * INTACT — galerie produit
 * Crossfade doux entre l'image principale et la miniature sélectionnée,
 * + zoom léger au clic (lightbox minimale, sans librairie).
 */
(function () {
  function initGallery(gallery) {
    var mainImage = gallery.querySelector("[data-gallery-main] img");
    var thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
    var lightbox = gallery.querySelector("[data-gallery-lightbox]");
    var lightboxImage = lightbox ? lightbox.querySelector("img") : null;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var newSrc = thumb.getAttribute("data-full-src");
        var newAlt = thumb.getAttribute("data-full-alt") || "";
        if (!newSrc || !mainImage) return;

        thumbs.forEach(function (t) {
          t.classList.remove("gallery__thumb--active");
        });
        thumb.classList.add("gallery__thumb--active");

        mainImage.classList.add("gallery__main-image--fading");
        window.setTimeout(function () {
          mainImage.src = newSrc;
          mainImage.alt = newAlt;
          mainImage.classList.remove("gallery__main-image--fading");
        }, 200);
      });
    });

    if (mainImage && lightbox && lightboxImage) {
      mainImage.addEventListener("click", function () {
        lightboxImage.src = mainImage.getAttribute("src");
        lightboxImage.alt = mainImage.getAttribute("alt") || "";
        lightbox.classList.add("gallery__lightbox--open");
        document.body.classList.add("no-scroll");
      });

      lightbox.addEventListener("click", function (event) {
        if (event.target === lightbox || event.target.hasAttribute("data-gallery-close")) {
          lightbox.classList.remove("gallery__lightbox--open");
          document.body.classList.remove("no-scroll");
        }
      });

      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
          lightbox.classList.remove("gallery__lightbox--open");
          document.body.classList.remove("no-scroll");
        }
      });
    }
  }

  document.querySelectorAll("[data-product-gallery]").forEach(initGallery);
})();
